import { useState } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { API } from '../../lib/api';

const EditContactModal = ({ contact, onClose, onSaved }) => {
    const [values, setValues] = useState({
        firstName: contact.firstName || '',
        lastName: contact.lastName || '',
        primaryEmail: contact.primaryEmail || '',
        jobTitle: contact.jobTitle || contact.contactJobTitle || '',
        phoneNumber: contact.phoneNumber || '',
    });
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (saving) return;
        setSaving(true);
        setError('');
        try {
            const updated = await API.Contacts.UpdateSingle(contact._id, values);
            onSaved(updated);
        } catch (err) {
            setError(err.response?.data?.message || 'Unable to save contact. Please try again.');
        } finally {
            setSaving(false);
        }
    };

    return <Dialog open onClose={() => { if (!saving) onClose(); }} fullWidth maxWidth="sm" aria-labelledby="edit-contact-title">
        <Box component="form" onSubmit={handleSubmit}>
            <DialogTitle id="edit-contact-title">Edit Contact</DialogTitle>
            <DialogContent dividers>
                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                <Box sx={{ display: 'grid', gap: 2, pt: 1 }}>
                    {[
                        ['firstName', 'First Name', 'text'],
                        ['lastName', 'Last Name', 'text'],
                        ['primaryEmail', 'Primary Email', 'email'],
                        ['jobTitle', 'Job Title', 'text'],
                        ['phoneNumber', 'Phone #', 'tel'],
                    ].map(([name, label, type], index) => <TextField key={name} name={name} label={label} type={type}
                        value={values[name]} onChange={(event) => setValues((previous) => ({ ...previous, [name]: event.target.value }))}
                        disabled={saving} autoFocus={index === 0} fullWidth />)}
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button onClick={onClose} disabled={saving} sx={{ textTransform: 'none' }}>Cancel</Button>
                <Button type="submit" variant="contained" disabled={saving} sx={{ textTransform: 'none' }}>{saving ? 'Saving…' : 'Save Changes'}</Button>
            </DialogActions>
        </Box>
    </Dialog>;
};

export default EditContactModal;
